import { DataSourceCode } from "@syla/shared/types/models/DataSourceBase";
import { DataSourceWithNetworks } from "@syla/shared/types/responses/DataSourceWithNetworks";

export function getEstimatedSyncTime({
  mappedToCode,
  code,
}: DataSourceWithNetworks) {
  if ((mappedToCode ?? code) === DataSourceCode.Binance) {
    return "15min to 1hr";
  }

  return undefined;
}
